module.exports = __webpack_public_path__ + "static/media/BIO.4c6fdc6f.jpg";